import type { DeviceCore, Device } from 'src/models/device';

export interface DeviceCoreResponse {
  id: number;
  device_id: string;
  car_name: string;
  car_kind: string;
  group_id: number;
  machine_type: string | null;
  firmware_version: string | null;
  settings: string | null;
  device_attached_on: string | null;
  stopped_use_on: string | null;
  avatar_url: string | null;
  bikou1: string | null;
  deleted_at: string;
}

export interface DeviceResponse extends DeviceCoreResponse {
  g2id: number;
  g2name: string;
  g2disp_order: number | null;
  g3id: number;
  g3name: string;
  g3disp_order: number | null;
}

export type DeviceIndexResponse = DeviceResponse[];

export const toDeviceCore = (response: DeviceCoreResponse): DeviceCore => ({
  id: response.id,
  deviceId: response.device_id,
  carName: response.car_name,
  carKind: response.car_kind,
  groupId: response.group_id,
  machineType: response.machine_type,
  firmwareVersion: response.firmware_version,
  settings: response.settings,
  deviceAttachedOn: response.device_attached_on,
  stoppedUseOn: response.stopped_use_on,
  avatarUrl: response.avatar_url,
  bikou1: response.bikou1,
  deletedAt: response.deleted_at,
});

export const toDevice = (response: DeviceResponse): Device => ({
  ...toDeviceCore(response),
  groupInfo: {
    g2id: response.g2id,
    g2name: response.g2name,
    g2dispOrder: response.g2disp_order,
    g3id: response.g3id,
    g3name: response.g3name,
    g3dispOrder: response.g3disp_order,
  },
});
